import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TimelineService } from 'src/app/timeline/timeline.service';

@Component({
    selector: 'app-delete-task',
    templateUrl: './delete-task.component.html',
    styleUrls: ['./delete-task.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteTaskComponent implements OnInit {

	@Input() task: any;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	loading: boolean = false;

	close() {
		this.closeView.emit();
	}

	submitForm() {
		this.loading = true;
		this._tS.deletePhaseTask(this.task.id).subscribe(
			data => {
				this.loading = false;
				this.notify.emit();
			}
		)
	}

	constructor(public _gS: GlobalService, private _tS: TimelineService) { }

	ngOnInit() {
	}

}
